import { useContext } from 'react';
import { Button, Flex, Link, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { MeContext } from '../../context/MeContext';
import { useIsReadOnly } from '../../hooks/useIsReadOnly';
import { CustomLockIcon } from '../../theme/icons/CustomLockIcon';
import GradientBorderCard from '../../common/GradientBorderCard';

const ReadOnlyBanner = () => {
  const navigate = useNavigate();
  const isReadOnly = useIsReadOnly();
  const meCtx = useContext(MeContext);
  const { organisationStatus, trialExpiry, account, billingEnabled } =
    meCtx.state;

  if (!isReadOnly) return null;

  const isTrialExpired = organisationStatus === 'trial_expired';
  const canSelfServe = billingEnabled === true;
  const companyName = account?.company_name || '';

  const extensionEmailHref = `mailto:sales@passentry.com?cc=support@passentry.com&subject=${encodeURIComponent(
    `Trial extension request — ${companyName}`
  )}&body=${encodeURIComponent(
    `Our trial expired on ${
      trialExpiry ? new Date(trialExpiry).toLocaleDateString('en-GB') : ''
    }. We would like an extension because…`
  )}`;
  const salesEmailHref = `mailto:sales@passentry.com?cc=support@passentry.com&subject=${encodeURIComponent(
    `Reactivate account — ${companyName}`
  )}`;

  const actionMessage = canSelfServe
    ? isTrialExpired
      ? 'Choose a plan to continue using the platform.'
      : 'Reactivate your subscription to continue using the platform.'
    : 'Contact our team to continue using the platform.';

  return (
    <GradientBorderCard
      bg="white"
      p={0}
      borderRadius="12px"
      mt={4}
      mx={{ base: 4, lg: 0 }}
    >
      <Flex px={5} py={3} align="center" gap={4} flexWrap="wrap">
        <Flex
          bg="dangerRedLight"
          borderRadius="8px"
          boxSize="36px"
          align="center"
          justify="center"
          flexShrink={0}
        >
          <CustomLockIcon fill="dangerRed" boxSize="14px" />
        </Flex>
        <Text flex="1" minW="240px" fontSize="15px" color="jetBlack">
          <Text as="span" fontWeight="700">
            {isTrialExpired
              ? 'Your trial has ended.'
              : 'Your account is locked.'}
          </Text>{' '}
          Everything you built is saved and read-only. {actionMessage}
        </Text>
        {canSelfServe && isTrialExpired && (
          <Link
            href={extensionEmailHref}
            textDecoration="underline"
            color="textGrey"
            fontSize="15px"
            whiteSpace="nowrap"
          >
            Need more time?
          </Link>
        )}
        {canSelfServe ? (
          <Button
            variant="gradient"
            size="md"
            px={8}
            w={{ base: 'full', md: 'auto' }}
            onClick={() => navigate('/my-account?openGoLive=1')}
          >
            {isTrialExpired ? 'Choose a plan' : 'Reactivate'}
          </Button>
        ) : (
          <Button
            as="a"
            href={salesEmailHref}
            variant="gradient"
            size="md"
            px={8}
            w={{ base: 'full', md: 'auto' }}
          >
            Contact sales
          </Button>
        )}
      </Flex>
    </GradientBorderCard>
  );
};

export default ReadOnlyBanner;
